import React, {useCallback} from "react";
import {useParams} from "react-router";
import {DiaEditorCreateRedirectFunction, useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import { GetPosterSizeImageQueryResult, PosterSize, UpdatePosterSizeMutation, UpdatePosterSizeMutationResult, useGetPosterSizeImageQuery, useUpdatePosterSizeMutation } from '../../generated/graphql';
import { useUserContext } from "../../contexts/user-context";
import PosterSizeImageForm from "./Form";

const blankValues = (): PosterSize =>{
    return {
        id:'',
        name:'loading'
    };
};

const relationships = {
    'images':'create',
};

const PosterSizeImageEditor = () => {
    const params = useParams();
    const user = useUserContext();
    const query = useGetPosterSizeImageQuery({variables:{id:params?.id??''}});
    const [saveMutation,saveResult] = useUpdatePosterSizeMutation();
    const readOnly = !(user.hasPermission('postersizes.edit'));
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[saveMutation]);
    const getValue = useCallback((result:GetPosterSizeImageQueryResult)=>{
        return result?.data?.posterSize;
    },[]);
    const getSaveValue = useCallback((result:UpdatePosterSizeMutationResult)=>{
        return result?.data?.updatePosterSize;
    },[]);
    const data = useDiaEditor<PosterSize,GetPosterSizeImageQueryResult,null,UpdatePosterSizeMutation,null>({
        save,
        saveResult,
        query:query,
        baseUrl:'/database/postersize-images/',
        label:'Poster Size Images',
        permission:'poster_sizes',
        getValue:getValue,
        relationships,
        blankValues,
        getSaveValue:getSaveValue
    });
    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if(data.form.status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    console.log('data is',data);
    return <><PosterSizeImageForm diaForm={data.form} readOnly={readOnly}/>
        {data.confirmation}
    </>;
}

export default PosterSizeImageEditor;